<template>
  <div class="containerShipment table-responsive col-12">
    <li
      style="
        display: block;
        color: #000000;
        font-family: dfyuanstd-w5, dfyuanstd-w3;
        font-size: 1rem;
      "
    >
      成品倉
    </li>
    <b-table
      :items="containerShipmentItem.finished"
      :fields="containerShipmentFields"
      class="text-center containerShipment-table-detail mb-2"
    >
    </b-table>

    <li
      style="
        display: block;
        color: #000000;
        font-family: dfyuanstd-w5, dfyuanstd-w3;
        font-size: 1rem;
      "
    >
      已入庫
    </li>
    <b-table
      :items="containerShipmentItem.warehousing"
      :fields="containerShipmentFields"
      class="text-center containerShipment-table-detail mb-2"
    >
    </b-table>

    <li
      style="
        display: block;
        color: #000000;
        font-family: dfyuanstd-w5, dfyuanstd-w3;
        font-size: 1rem;
      "
    >
      未入庫
    </li>
    <b-table
      :items="containerShipmentItem.not_warehousing"
      :fields="containerShipmentFields"
      class="text-center containerShipment-table-detail mb-2"
    >
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "containerShipment",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      containerShipmentFields: "containerShipment/get_containerShipmentFields",
      containerShipmentItem: "containerShipment/get_containerShipmentItem",
    }),
  },
};
</script>

<style lang="scss">
.containerShipment-table-detail thead th {
  white-space: nowrap;
  border-top: 1px solid;
}
.containerShipment-table-detail th,
.containerShipment-table-detail td {
  font-size: 1rem;
  min-width: 65px;
  padding: 0.1rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  background-color: #ffffff;
  vertical-align: middle !important;
}

.containerShipment-table-detail th:first-child,
.containerShipment-table-detail td:first-child {
  border-left: 1px solid;
}

.containerShipment-table-detail td:nth-child(3) {
  max-width: 600px;
}

.containerShipment-table-detail {
  margin-bottom: 0px;
}
.containerShipment-table-detail thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}
</style>



// WEBPACK FOOTER //
// src/components/containerShipment.vue